import React from 'react';
import { Box, Breadcrumbs, Stack, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './Breadcrumb.scss';

const Breadcrumb = () => {
  const location = useLocation();
  const pathForHidingBreadcrumb = ['/dashboard'];
  const hideBreadcrumb = pathForHidingBreadcrumb.includes(location.pathname);
  const breadcrumbs = useSelector((state) => state.config.breadCrumbLinks);
  const navigate = useNavigate();
  return (
    <>
      {!hideBreadcrumb ? (
        <Box
          className='breadcrumb-container'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '12px',
          }}
        >
          <Stack
            gap={2}
            direction={'row'}
            alignItems={'center'}
            onClick={() => navigate(-1)}
            sx={{ cursor: 'pointer' }}
          >
            <NavigateBeforeIcon fontSize='small' />
            <Typography className='bread-crumb-label'>Back</Typography>
          </Stack>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize='small' />}
            aria-label='breadcrumb'
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Box>
      ) : null}
    </>
  );
};

export default Breadcrumb;
